export default () => useState<Record<string, HTMLElement | null>>('sticky', () => ({}))
